import multipleStringReplace from '@helpers/multiple-string-replace'
import generateCheckAvailDates from './generateCheckAvailDates'

const URL_TEMPLATES = {
	US: 'https://prf.hn/click/camref:1100lvTKa/pubref:hoco-[cl_id]/ar:[pid]/destination:https://www.hotels.com/Hotel-Search?destination=[city]-[country]&startDate=[check_in]&endDate=[check_out]',
	GB: 'https://hotels.prf.hn/click/camref:1100lvTK9/pubref:hoco-[cl_id]/ar:[pid]/destination:https://uk.hotels.com/Hotel-Search?destination=[city]-[country]&startDate=[check_in]&endDate=[check_out]',
}

const { checkIn, checkOut } = generateCheckAvailDates()

const generateHotelscomUrl = ({
	cl_id = shared.options.cl_id, // cluster id
	pid = shared.options.pid, // post id
	city = shared.options.dest_name, // city
	country = shared.options.country || '', // country
	country_code = shared.options.user?.country_code || '',
	check_in = checkIn,
	check_out = checkOut,
}) => {
	try {
		const url = multipleStringReplace(URL_TEMPLATES[country_code], {
			cl_id,
			pid,
			city,
			country,
			check_in,
			check_out,
		})

		return url
	} catch (error) {
		throw new Error(`Error while generating hotelscom url: ${error}`)
	}
}

export default generateHotelscomUrl
